// Support contact links. Their visible text is footer-support-email and
// footer-support-phone in the localizations.
export const SUPPORT = {
    emailHref: "mailto:support@globalforester.com",
    phoneHref: "tel:+46702643360",
};
